import React, { useState, useEffect } from "react";
import { useRecoilValue } from 'recoil';
import { isMobile, isTablet } from "react-device-detect";
import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import Switch from "@material-ui/core/Switch";

import * as RemindersApi from '../../../../Common/Apis/RemindersApi';
import { reminderListRefreshState } from '../../store/ReminderStore';
import { useSpinner } from "../../../../../core/contexts/SpinnerContext";
import ReminderListItem from "./ListItem";

interface IProps {
  addTab: any;
}

const ReminderList = ({ addTab }: IProps) => {
  const [listData, setListData] = useState();
  const [pageSize, setpageSize] = useState((isMobile && !isTablet) ? 10 : 100);
  const [, setpageNo] = useState(1);
  const [actionRequired, setActionRequired] = useState(false);
  const [alertCount, setAlertCount] = useState(0);

  const listRefresh = useRecoilValue(reminderListRefreshState);

  const { setSpinner } = useSpinner();

  useEffect(() => {
    getList(1, pageSize);
    getAlertCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listRefresh, actionRequired]);



  // const refreshPage = () => {

  //   getList(pageNo, pageSize);
  //   getAlertCount();
  // };

  const pageSizeChanged = (i: number) => {
    setpageSize(i);
    setpageNo(1);
    getList(1, i);
  };

  const pageNoChanged = (i: number) => {
    setpageNo(i);
    getList(i, pageSize);
  };

  const getAlertCount = async () => {
    try {

      const resData = await RemindersApi.getReminderActionRequireCount();

      setAlertCount(resData.Count);

    } catch (err) {
      console.log('err', err);
    }
  };

  const getList = async (_pageNo: number, _pageSize: number) => {

    setSpinner(true);

    try {

      let resData;

      if (actionRequired) {
        resData = await RemindersApi.getReminderActionRequireList(_pageNo, _pageSize);
      }
      else {
        resData = await RemindersApi.getReminderList(_pageNo, _pageSize);
      }

      //console.log("resData", resData);
      setListData(resData);

    } catch (err) {
      console.log('err', err);
    }

    setSpinner(false);
  };

  return (
    <>
      <div className="row no-gutters">
        <div className="col-lg-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <div className="card">
              <div className="card-body">
                <div className="row ">
                  <div className="col-lg-1">
                    <div className="form-group">
                      <Button
                        type="submit"
                        //className=" ml-3"
                        style={{ fontWeight: '600' }}
                        variant="contained"
                        color="primary"
                        onClick={() => getList(1, pageSize)}
                      >
                        Refresh
                      </Button>

                    </div>

                  </div>
                  <div className="col-lg">
                    <Switch
                      size="small"
                      checked={actionRequired}
                      onChange={_e => setActionRequired(!actionRequired)}
                      color="primary"
                      name="checkedB"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                    <span className="contents-black" >
                      <Badge badgeContent={alertCount} color="primary">
                        Action Required
                      </Badge>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            {listData && <ReminderListItem
              items={listData}
              addTab={addTab}
              pageSizeChanged={pageSizeChanged}
              pageNoChanged={pageNoChanged}
            />}

          </div>
        </div>
      </div>
    </>
  );
};

export default ReminderList;